import appConstants from '../../../../../../../../../appConstants';
import { DateTimeEditor } from '@dataGrid/components/cellEditors';
import { IBETARenderer } from '@dataGrid/components/cellRenderer';
import { DateTimeFilter, MultiSelectFilter } from '@dataGrid/components/columnFilters';
import { customAlphanumericComparator, formatDateTime } from '@dataGrid/gridUtilities';
import {
  getCustomerName,
  ibEtaValueFormatter
} from '../../../../../../../../modules/IBPlanning/ShipmentsView/utils';
import CheckBoxRenderer from '../../../CheckBoxRenderer';
import DotRenderer from '../../../DotRenderer';
import {
  CheckIfAllProIncluded,
  checkIfProIncluded,
  checkIsNotModified,
  handleCheckboxToggle,
  handleCheckboxToggleForAll
} from '../../utils';

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = 'GridConfiguration';
    this.config = GridConfig.getConfiguration(config);
  }

  static getConfiguration() {
    return GridConfig.getDefaultConfiguration();
  }

  static isIBetaEditable(params) {
    return !params.data.actualArrivalTime;
  }

  static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.ShipmentsGrid,
      keyColumn: 'proId',
      rowSelection: 'multiple',
      rowDeselection: 'true',
      defaultColDef: {
        sortable: true,
        filter: true
      },
      columns: [
        {
          headerName: '',
          cellRenderer: CheckBoxRenderer,
          headerComponent: CheckBoxRenderer,
          valueGetter: (params) => checkIfProIncluded(params),
          cellRendererParams: (params) => ({
            onChange: (isChecked) => handleCheckboxToggle(params, isChecked)
          }),
          headerComponentParams: (params) => ({
            value: CheckIfAllProIncluded(params),
            onChange: (isChecked) => handleCheckboxToggleForAll(params, isChecked)
          }),
          headerClass: 'checkBoxHeader',
          cellClassRules: {
            'gridCell-centerAlign': true
          },
          pinned: 'left',
          lockPosition: true,
          lockPinned: true,
          isInvisibleInShowHide: true,
          minWidth: appConstants.columnWidth.W_64,
          maxWidth: appConstants.columnWidth.W_64
        },
        {
          headerName: '',
          pinned: "left",
          minWidth: appConstants.columnWidth.VIOLATION_DOT,
          maxWidth: appConstants.columnWidth.VIOLATION_DOT,
          valueGetter: checkIsNotModified,
          lockPosition: true,
          lockPinned: true,
          cellClass: ['gridCell-centerAlign', "gridCell-dot"],
          filter: false,
          cellRenderer: DotRenderer
        },
        {
          headerName: 'Pro#',
          headerTooltip: 'Pro ID',
          field: 'proId',
          minWidth: appConstants.columnWidth.PROID,
          filter: MultiSelectFilter,
          filterParams: {
            filterType: appConstants.FILTER_TYPES.STRING
          }
        },
        {
          headerName: 'Customer',
          headerTooltip: 'Customer Name',
          field: 'consigneeName',
          minWidth: appConstants.columnWidth.CUSTOMER,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          valueGetter: getCustomerName,
          tooltipValueGetter: (params) => params.value
        },
        {
          headerName: 'Shipment Status',
          headerTooltip: 'Shipment Status',
          field: 'shipmentStatus',
          minWidth: appConstants.columnWidth.SHIPMENT_STATUS,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          tooltipField: 'shipmentStatus'
        },
        {
          headerName: 'Bay Location',
          headerTooltip: 'Bay Location',
          field: 'bayLocation',
          cellClass: 'gridCell-leftAlign',
          minWidth: appConstants.columnWidth.W_130,
          filter: MultiSelectFilter,
          filterParams: {
            filterType: appConstants.FILTER_TYPES.STRING
          },
          comparator: customAlphanumericComparator
        },
        {
          headerName: 'Curr Trlr',
          headerTooltip: 'Trailer ID',
          field: 'trailerNumber',
          minWidth: appConstants.columnWidth.TRAILER_ID,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter
        },
        {
          headerName: 'Next Term',
          headerTooltip: 'Next Terminal',
          field: 'nextTerminal',
          minWidth: appConstants.columnWidth.TERMINAL,
          filter: MultiSelectFilter
        },
        {
          headerName: 'IB ETA',
          headerTooltip: 'Shipment ETA',
          field: 'shipmentEtaDateTime',
          minWidth: appConstants.columnWidth.IBETA,
          valueFormatter: ibEtaValueFormatter,
          cellRenderer: IBETARenderer,
          cellEditor: DateTimeEditor,
          cellEditorPopup: true,
          editable: GridConfig.isIBetaEditable,
          cellEditorParams: {
            DATETYPE: appConstants.DATETYPES.DATETIME
          },
          filter: DateTimeFilter,
          filterParams: {
            DATETYPE: appConstants.DATETYPES.DATETIME
          }
        },
        {
          headerName: 'Act Arr Time',
          headerTooltip: 'Actual Arrival Time',
          field: 'actualArrivalTime',
          minWidth: appConstants.columnWidth.IBETA,
          cellClass: 'gridCell-leftAlign',
          valueFormatter: formatDateTime,
          filter: DateTimeFilter,
          filterParams: {
            DATETYPE: appConstants.DATETYPES.DATETIME
          }
        }
      ]
    };
  }
}
